module.exports = __webpack_public_path__ + "img/cooperate_yx_01@2x.726155f4.png";